import TablaYounet from '../Elementos/TablaYounet';


const Element =()=>{

    const headCellsColumn = [
        { id: 'Opcion', numeric: false, disablePadding: false, label: 'OPCION', show:true, fixed:false, width:150, num:0, align:'left', fontSize:'15px', bolder:false, type:'text' },
        { id: 'Respuesta', numeric: false, disablePadding: false, label: 'RESPUESTA', show:true, fixed:false, width:1100, num:1, align:'left', fontSize:'15px', bolder:false, type:'text' },
    ];

    const variablesObject = {
        api:'/api/Whatsapps',
        apiMultiples:'/api/Whatsapps/multiple',
        isButtonAdd:true,
        isMultiline:true,
        isUpperCase:false,   
        label:'WHATSAPP',
        nameLocalStorage:'headersWhatsappsYounet',
        order:'asc',
        orderBy:'Opcion',
        rowsPerPage:15,
        sumWidth:1419,
        title:'WHATSAPPS',
        titleColor:'#3b5999',
        titleSizeXL:18,
        titleSizeXS:13,
        widthAction:160,
    };

    return (
        <TablaYounet
            headCellsColumn={headCellsColumn}
            variablesObject={variablesObject}
        />
    )
}

export default Element;